namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    import Endpoints = Portico.Models.Interfaces;
    import IAccessToken = Portico.Models.Interfaces.IAccessToken;
    import ResponseModel = Portico.Models.Enterprise.ResponseModel;
    import IResponseModel = Portico.Models.Interfaces.IResponseModel;
    
    export interface ITokenService {
        requestToken(serviceDef: Endpoints.IServiceDefinition): ng.IPromise<string>;
    }

    @Service('app', 'tokenService')
    @Inject('$http', '$q', 'storageService')
    export class TokenService implements ITokenService {
        private promiseCache = {};

        constructor(protected $http: ng.IHttpService,
            protected $q: ng.IQService,
            protected storageService: Portico.Services.StorageService) {

            this.$http.defaults.headers.common['accept'] = 'application/json';
            this.$http.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
        }

        requestToken(serviceDef: Endpoints.IServiceDefinition): ng.IPromise<string> {
            if (serviceDef.url.substr(-1) === '/') {
                serviceDef.url = serviceDef.url.substr(0, serviceDef.url.length - 1);
            }

            if (!serviceDef.audienceId) {
                return this.$q.when('');
            }

            const token = this.storageService.getItem<IAccessToken>(Models.StorageType.Session, serviceDef.storageKey);

            if (token) {
                if ((new Date(token.expiresOnUtc) <= new Date()) && this.promiseCache[serviceDef.audienceId] == undefined) {
                    this.storageService.deleteItem(Models.StorageType.Session, serviceDef.storageKey);
                } else {
                    return this.$q.when('Bearer ' + token.token);
                }
            }

            if (this.promiseCache[serviceDef.audienceId]) {
                return this.promiseCache[serviceDef.audienceId];
            }

            const config = { withCredentials: true };

            return this.promiseCache[serviceDef.audienceId] = this.$http.post<IResponseModel<IAccessToken>>('/api/Token/' + serviceDef.audienceId, undefined, config)
                .then((response) => {
                    var model = new ResponseModel<IAccessToken>(response.data);

                    return model.success
                        ? this.$q.when(model.data)
                        : this.$q.reject(model.messages);
                })
                .then((accessToken: IAccessToken): ng.IPromise<string> => {

                    this.storageService.saveItem(Models.StorageType.Session, serviceDef.storageKey, accessToken);
                    delete this.promiseCache[serviceDef.audienceId];

                    return this.$q.when('Bearer ' + accessToken.token);
                });

        }
    }
}